import api from '../api';
import { tokenStorage } from '../../utils/encryptedCookie';

const setAuthHeader = () => {
  const token = tokenStorage.get();
  if (token) {
    return { Authorization: `Bearer ${token}` };
  }
  return {};
};

export const getAllPersons = async (filters, page, size) => {
  try {
    const response = await api.get(`/person`, {
      headers: setAuthHeader(),
      params: {
        ...filters,
        page,
        size,
      },
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : new Error('Erro ao se comunicar com a API.');
  }
};

export const createPerson = async (personData) => {
  try {
    const response = await api.post('/person', personData, {
      headers: setAuthHeader(),
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Error creating person');
  }
};

export const getPersonData = async (personId) => {
  try {
    const response = await api.get(`/person/${personId}`, {
      headers: setAuthHeader(),
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : new Error('Erro ao buscar dados da persona.');
  }
};

export const getPersonByLicensePlateData = async (licensePlate) => {
  try {
    const response = await api.get('/person/licensePlate', {
      headers: setAuthHeader(),
      params: {
        licensePlate,
      },
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : new Error('Erro ao buscar dados da persona.');
  }
};

export const updatePerson = async (personId, data) => {
  try {
    const response = await api.put(`/person/${personId}`, data, {
      headers: setAuthHeader(),
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : new Error('Erro ao atualizar a persona.');
  }
};

export const getOtherOldId = async () => {
  try {
    const response = await api.get(`/person/oldId`, {
      headers: setAuthHeader(),
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : new Error('Erro ao buscar oldId.');
  }
};